import { jsx as _jsx } from "react/jsx-runtime";
export function Sheet({ children, style, ...rest }) {
    return (_jsx("div", { "data-sheet": "", ...rest, style: {
            background: "var(--sheet)",
            boxShadow: "var(--sheet-edge)",
            borderRadius: "var(--radius-sheet) var(--radius-sheet) 0 0",
            ...style,
        }, children: children }));
}
